import {createContext} from "react"
import {ToastProps} from "@/components/ui-kit/toast"

export type ToastMap = { [key: string]: ToastProps }

export type ToastType = {
    toasts: ToastMap
    toast: (key: string, data: Omit<ToastProps, 'refKey' | 'removed'>) => void
    closeToast: (key: string) => void
    clear: () => void
}
export const ToastContext = createContext<ToastType>({
    toasts: {},
    toast: () => {
        throw new Error("No toast() was provided...")
    },
    closeToast: () => {
        throw new Error("No closeToast() was provided...")
    },
    clear: () => {
        throw new Error("No clear() was provided...")
    },
})
